import Link from 'next/link';

import { Typography } from '@gds/Typography/Typography';
import type { ImageObj } from '@umbraco/Entities/SharedEntities.types';

import { MediaImage } from '../../MediaImage/MediaImage';

import styles from './BrandsExpandable.module.css';

type BrandItemProps = { label: string; link: string | null; image: ImageObj | null | undefined };

export const BrandItem = ({ label, link, image }: BrandItemProps) => (
  <Link href={link || '/'} aria-label={label} className={styles.brandItem}>
    <div className={styles.imageContainer}>
      {image && (
        <MediaImage
          image={image}
          alt={`${label} logo`}
          objectFit="contain"
          sizes="15vw"
          loading="lazy"
        />
      )}
    </div>
    <Typography variant="body3" className={styles.brandName}>
      {label}
    </Typography>
  </Link>
);
